import { HttpClient } from "@angular/common/http";
import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-image-previewer",
  templateUrl: "./image-previewer.component.html",
  styleUrls: ["./image-previewer.component.css"],
})
export class ImagePreviewerComponent implements OnInit {
  isLoading: boolean = true;
  isError: boolean = false;
  reason: string;
  image: any;
  imageUrl: string;
  scale: number = 0.5;
  showLoader = true;
  constructor(
    private matDialogRef: MatDialogRef<ImagePreviewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.http
      .get(
        "https://storagehseglobaldev.blob.core.windows.net/travel-protocol/Covid19Controls.png"
      )
      .subscribe((resp) => {
        console.log(resp);
      });
  }

  setShowLoader() {
    this.showLoader = false;
  }
}
